const questions = [
  {
    question: 'Does your system hyper targetted?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Manage your retail sales without a hussle.',
  },
  {
    question: 'Are you offering operator-free purchase?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Bring on innovations in your business on an on-going manner.',
  },
  {
    question: 'Can you customers pre-order fuel and pay via mobile?',
    answer:
      'Bring on innovations in your business on an on-going manner. Bring on innovations in your business on an on-going manner. ',
  },
  {
    question: 'Does your system hyper targetted?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Manage your retail sales without a hussle.',
  },
  {
    question: 'Are you offering operator-free purchase?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Bring on innovations in your business on an on-going manner.',
  },
  {
    question: 'Can you customers pre-order fuel and pay via mobile?',
    answer:
      'Bring on innovations in your business on an on-going manner. Bring on innovations in your business on an on-going manner. ',
  },
  {
    question: 'Does your system hyper targetted?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Manage your retail sales without a hussle.',
  },
  {
    question: 'Are you offering operator-free purchase?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Bring on innovations in your business on an on-going manner.',
  },
  {
    question: 'Can you customers pre-order fuel and pay via mobile?',
    answer:
      'Bring on innovations in your business on an on-going manner. Bring on innovations in your business on an on-going manner. ',
  },
  {
    question: 'Does your system hyper targetted?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Manage your retail sales without a hussle.',
  },
  {
    question: 'Are you offering operator-free purchase?',
    answer:
      'Manage your retail sales without a hussle. Manage your retail sales without a hussle. Bring on innovations in your business on an on-going manner.',
  },
  {
    question: 'Can you customers pre-order fuel and pay via mobile?',
    answer:
      'Bring on innovations in your business on an on-going manner. Bring on innovations in your business on an on-going manner. ',
  },
];

export default questions;
